module.exports = __webpack_public_path__ + "img/img_blank_content@2x.722080ea.png";